import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAV_ITEMS } from '../data/siteData';
import Logo from './Logo';

function buildHref(item, isHome) {
  if (item.external) return item.external;
  if (item.page) return item.page + (item.hash || '');
  if (isHome) return item.homeHash;
  return '/' + item.homeHash;
}

function isActive(item, pathname, hash, isHome) {
  if (item.page) {
    const pagePath = item.page.split('#')[0];
    if (pathname === pagePath || pathname === pagePath + '/') {
      if (item.hash) return hash === item.hash;
      return true;
    }
    return false;
  }
  if (isHome && item.homeHash) {
    const currentHash = hash || '#sobre';
    return currentHash === item.homeHash;
  }
  return false;
}

function NavLink({ item, isHome, pathname, hash, onNavigate }) {
  const href = buildHref(item, isHome);
  const active = isActive(item, pathname, hash, isHome);
  const cls = 'in-nav__link' + (active ? ' in-nav__link--active' : '');

  if (href.includes('.html') || href.startsWith('http')) {
    return (
      <a className={cls} href={href} onClick={onNavigate}>
        {item.label}
      </a>
    );
  }

  if (href.startsWith('#')) {
    return (
      <a className={cls} href={href} onClick={onNavigate}>
        {item.label}
      </a>
    );
  }

  return (
    <Link
      className={cls}
      to={href}
      onClick={() => {
        onNavigate?.();
        if (item.hash) {
          setTimeout(() => {
            document.querySelector(item.hash)?.scrollIntoView({ behavior: 'smooth' });
          }, 100);
        }
      }}
    >
      {item.label}
    </Link>
  );
}

export default function Header() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="in-header" id="site-header">
      <div className="in-header__bar">
        <a className="in-logo-link" href={isHome ? '#sobre' : '/#sobre'}>
          <Logo />
        </a>

        <nav className="in-nav" aria-label="Menu principal">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.label}
              item={item}
              isHome={isHome}
              pathname={location.pathname}
              hash={location.hash}
            />
          ))}
        </nav>

        <a
          href="https://wa.me/5544991775641"
          className="in-header__cta"
          target="_blank"
          rel="noopener noreferrer"
        >
          Fale conosco
        </a>

        <button
          type="button"
          className="in-menu-btn"
          aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'} />
        </button>
      </div>

      <nav
        className={'in-mobile-nav' + (menuOpen ? ' in-mobile-nav--open' : '')}
        aria-label="Menu mobile"
      >
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.label}
            item={item}
            isHome={isHome}
            pathname={location.pathname}
            hash={location.hash}
            onNavigate={closeMenu}
          />
        ))}
        <a
          href="https://wa.me/5544991775641"
          className="in-btn in-btn--primary"
          style={{ marginTop: 8 }}
          target="_blank"
          rel="noopener noreferrer"
          onClick={closeMenu}
        >
          Fale conosco
        </a>
      </nav>
    </header>
  );
}
